import type { FaireProductEntity } from "../../entity_types/product";

export const p_2mgspra5zw: FaireProductEntity = {
  token: "p_2mgspra5zw",
  type: "product",
  name: "Custom city/state Pressed flower handmade trinket dish White",
  brandToken: "b_7j6yttrrz2",
  brandName: "Tara Kothari",
  imageUrl:
    "https://cdn.faire.com/fastly/02c56f6bb0cfbb20b3fc2462186135bb1c3e78e97eca52c99f8361844823018b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77c231d2859811bedc3caa75e0eb38337aa30fcda6ba65eb9bfe5d1838485ec7.jpeg",
    "https://cdn.faire.com/fastly/1aee692186ff47074111609349745da16c6e583e87e4979580dcd8fde349b6f3.jpeg",
    "https://cdn.faire.com/fastly/bb7dd791a77428dd5443491a621b9b2f7d7531e471f676cc029825c92a6a2419.jpeg",
    "https://cdn.faire.com/fastly/0f6d1b6a5192e0bc903d48a1d2456087d7a0823b63b50936e5116c7b13115cc2.jpeg",
    "https://cdn.faire.com/fastly/285cb8c728c5aba128bba9b8ec21b6228d3a3d8d904932dd22739f4c59bfca26.jpeg",
    "https://cdn.faire.com/fastly/a89b757508cde779a21f050f1b7f76cdc8ff4dedcbd508644dd983f0399e66c4.jpeg",
    "https://cdn.faire.com/fastly/aff836dfe302e6c2ea629923be240827ac64abd42532bd39da517c23b4ed4bba.jpeg",
    "https://cdn.faire.com/fastly/40a26157180a3bf16863eccaeee4375a7762575fa2378cff3d36184301f185dd.jpeg",
    "https://cdn.faire.com/fastly/5b8ae56d2339a813b32e015cccc008bc4d952ba0c99b9f609811117d6aa1d68c.jpeg",
    "https://cdn.faire.com/fastly/fc463f20e615d1b0618467433bdcf99de3ac53045f7dab0d4429ae913fa12556.jpeg",
  ],
  priceDollars: 23.29,
  description:
    'A light weight stoneware dish with pressed flowers in clay & hand painted monogramed with custom city/town name. \n\nEach piece is made by hand and has real flowers pressed in clay along with simple messages stamped in. Every piece is unique & varies not only because it is hand made, but because it has unique flowers pressed in and individually hand painted. \n\nThese easy to carry dishes make perfect souvenirs & little town vacation gifts.\n\nHandmade using stoneware clay. \nAll dishes are one of a kind and all slightly unique, colors may slightly vary. \n\nFood safe and dishwasher safe. \nDimensions trinket dish -  4 1/2" x 4 1/2"x 1/4"\n\nNOTE 1- Flowers will be assorted by season. If you are particular, please send a note checking with me before placing order and I will do my best to accommodate. \n\nNOTE 2 - Maximum of 11 characters for custom name. Filled in BLACK underglaze\nMade to order & cannot be canceled. ',
  tags: [],
  msrpDollars: 46.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:34.186Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
